import routerOptions0 from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.13.2_typescript@5.6.3_vite@5.4.10/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}